import { render, staticRenderFns } from "./TabLoginImage.vue?vue&type=template&id=bed08c14&"
import script from "./TabLoginImage.vue?vue&type=script&lang=js&"
export * from "./TabLoginImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports